var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "新規取込", visible: _vm.dialogVisible, width: "55em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("ImportForm", {
              ref: "importForm",
              attrs: {
                action: "/import-hangar-usages-data",
                label: "格納庫使用データファイル",
                formMode: "transaction",
                extension: "csv|txt"
              },
              on: {
                "import-success": _vm.importSuccess,
                "import-error": _vm.importError
              },
              model: {
                value: _vm.importFormModel,
                callback: function($$v) {
                  _vm.importFormModel = $$v
                },
                expression: "importFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("ImportDialogFooter", { on: { import: _vm.clickImport } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }